import {createSlice } from '@reduxjs/toolkit'

const MonthSlice = createSlice({
    name: "MonthSlice",
    initialState: {
        SelectedMonth: {
            id: 0,
            Name: '',
            MonthValue: 0,
            YearVelue: 0,
            BlockEdit: 'none'
        },
        MonthArray: [],
        WeekDay: ''
    },
    reducers: {
       MonthArrayAdd(state, actions){
            state.MonthArray = actions.payload
       },
       SelectMonth(state, actions){
        state.SelectedMonth = {
            id: 0,
            Name: '',
            MonthValue: 0,
            YearVelue: 0
        }
            state.SelectedMonth = actions.payload
       },
       ClearSelectedMonth(state){
        state.SelectedMonth = {
            id: 0,
            Name: '',
            MonthValue: 0,
            YearVelue: 0
        }
       },
       changeBlockEditSelectedMonth(state, actions){
        state.SelectedMonth.BlockEdit = actions.payload
       },
       setWeekDay(state, actions){
        state.WeekDay = actions.payload
       }
    }
})

export default MonthSlice.reducer
export const { MonthArrayAdd, SelectMonth, ClearSelectedMonth, setWeekDay, changeBlockEditSelectedMonth } = MonthSlice.actions